import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {ListsContext} from '../App';

export default function ResetButton() {
  const [open, setOpen] = React.useState(false); 

  return (
    <div className="app-reset">
      <Button variant="outlined" onClick={() => setOpen(true)} className="reset-btn">
        Reset
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="resetlist-dialog-title"
        aria-describedby="resetlist-dialog-description">
        <DialogTitle id="resetlist-dialog-title">Reset list?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            All counts will be set to 0. Are you sure to go ahead?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} autoFocus>
            Cancel
          </Button>
          <ListsContext.Consumer>
          {
            (context) => (
              <Button onClick={() => {setOpen(false); context.resetList();}} color="secondary">
                OK
              </Button>
            )
          }
          </ListsContext.Consumer>
        </DialogActions>
      </Dialog>
    </div>
  );
}